import { Modal} from 'react-bootstrap';
import JournalEditForm from './JournalEditForm';


export default function JournalEditModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Update Journal
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.form}

        <JournalEditForm key={props.currentJournal._id} journal={props.currentJournal} editJournal={props.editJournal} onHide={props.onHide}></JournalEditForm>

      </Modal.Body>
    </Modal>
  );
}